<div *ngIf="discrepancies.discrepancyFound" class="alert alert-warning alert-outline-coloured">
    <div class="alert-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line></svg>
    </div>
    <div class="alert-message">
      <strong>The following discrepancies were found:</strong>
      <ul class="ps-3 mb-0">
        <li *ngIf="discrepancies.odometer">Current odometer is lower than last known reading</li>
        <li *ngIf="discrepancies.manuallyEnteredDeductible">Deductible has been waived or changed</li>
        <li *ngIf="discrepancies.createdOverMonthOld">Date of occurrence is over a month old</li>
        <li *ngIf="!discrepancies.customerRecordMatch">Customer data does not match what is on file</li>
      </ul>
    </div>
  </div>
  <div *ngIf="!discrepancies.discrepancyFound" class="alert alert-info alert-outline-coloured">
    <div class="alert-icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
           stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <line x1="12" y1="16" x2="12" y2="12"></line>
        <line x1="12" y1="8" x2="12.01" y2="8"></line>
      </svg>
    </div>
    <div class="alert-message">No discrepancies found.</div>
  </div>